const _ = require('lodash');

const ProductGroupService = function ProductGroupService(restangular, $q, FiltersService, SearchService, decorateAdditionalDetails, $log, $state, $window, $timeout) {
    this._productGroupRoute = restangular.one('ProductGroup');
    this._productGroupsRoute = restangular.one('ProductGroups');
    this.selectedGroup = undefined;
    this.productGroupTitle = undefined;
    this.productGroupDescription = undefined;
    this.filtersService = FiltersService;
    this.searchService = SearchService;
    this.$q = $q;
    this.items = [];
    this._groupCache = {};
    this._decorator = decorateAdditionalDetails;
    this.$log = $log;
    this.$state = $state;
    this.$window = $window;
    this.$timeout = $timeout;
    this.batchTimeout = null;
    this.batchedProductGroupArgs = [];
    this.batchedProductGroupPromises = [];
};

ProductGroupService.prototype.selectProductGroup = function (id) {
    const self = this;

    if (!(id in this._groupCache)) {
        this._groupCache[id] = self._productGroupRoute.one(id).get();
    }

    this.productGroupPromise = this._groupCache[id].then(function (response) {
        self.selectedGroup = response;

        return response;
    });

    return this.productGroupPromise;
};

ProductGroupService.prototype.getSelectedProductGroup = function () {
    return this.productGroupPromise
        ? this.productGroupPromise
        : this.$q.when({});
};

ProductGroupService.prototype.listForVisualShopping = function () {
    const self = this;
    return self._productGroupRoute.one('ListForVisualShopping').get().then(items => {
        this.items = items;
        return items;
    });
};

function createArgs(args) {
    args.sortType = args.sortType === undefined ? 'Relevance' : args.sortType;
    args.showOnlyAvailable = args.showOnlyAvailable === undefined ? null : args.showOnlyAvailable;
    args.Location = args.Location === '/' ? '/Home' : args.Location;
    return {
        pageNumber: args.pageNumber,
        pageSize: args.pageSize || 10,
        sortType: args.sortType,
        filters: args.filters,
        showOnlyAvailable: args.showOnlyAvailable,
        ExcludeBanners: args.ExcludeBanners || false,
        ExcludeFacets: args.ExcludeFacets || false,
        Location: args.Location || ''
    };
}

function buildItems(response, self, args) {
    self.selectedGroupTotalCount = response.TotalRecordCount;
    if (args && args.filters) {
        self.filtersService.filters = response.Aggregations;
        self.filtersService.resultCount = response.TotalRecordCount;
    }

    _.each(response.Items, (bundle) => {
        self._decorator(bundle.Products);
    });

    return {
        items: response.Items,
        totalRecordCount: response.TotalRecordCount
    };
}

ProductGroupService.prototype.getProducts = function (args, group, isBatch) {

    const deferred = this.$q.defer();


    if (!group) {

        this.$log.error('Product group not found');
        deferred.resolve({
            items: [],
            totalRecordCount: 0
        });

    } else {
        const self = this;
        self.selectedGroupTotalCount = undefined;
        self.productGroupTitle = group.Description;
        self.productGroupDescription = group.DescriptionHtml;

        let request;

        if (group.Url) {
            request = group.Url;
        } else {
            request = group;
        }

        // add location to the args
        args.Location = this.$window.location.pathname;

        if (isBatch) {
            this.getProductsBatched(request, args, deferred);
        } else {
            if (args.filters && args.filters.length) {
                return self._productGroupRoute.one('Products').post(request, createArgs(args))
                    .then(response => { return buildItems(response, self, args); });
            }

            return self._productGroupRoute.one('Products/' + request).get(createArgs(args))
                .then(response => { return buildItems(response, self, args); });
        }
    }

    return deferred.promise;

};

ProductGroupService.prototype.getProductGroupsProducts = function (args, group) {

    const deferred = this.$q.defer();


    if (!group) {

        this.$log.error('Product group not found');
        deferred.resolve({
            items: [],
            totalRecordCount: 0
        });

    } else {
        const self = this;
        self.selectedGroupTotalCount = undefined;
        self.productGroupTitle = group.Description;
        self.productGroupDescription = group.DescriptionHtml;

        let request;

        if (group.Url) {
            request = group.Url;
        } else {
            request = group;
        }

        // add location to the args
        args.Location = this.$window.location.pathname;

        if (args.filters && args.filters.length) {
            return self._productGroupsRoute.one('Products').post(request, createArgs(args));
        }

        return self._productGroupsRoute.one('Products/' + request).get(createArgs(args));
    }

    return deferred.promise;

};

ProductGroupService.prototype.getProductsBatched = function (id, args, q) {
    this.batchedProductGroupArgs.push(args);
    this.batchedProductGroupPromises.push({ id, q });
    if (!this.batchTimeout) {
        this.batchTimeout = this.$timeout(() => this.executeBatch());
    }
};

ProductGroupService.prototype.executeBatch = function () {
    this.batchTimeout = null;
    const batchedProductGroupPromises = this.batchedProductGroupPromises;
    const batchedProductGroups = _.map(this.batchedProductGroupPromises, x => x.id);
    this.batchedProductGroupPromises = [];

    this.getProductGroupsProducts(this.batchedProductGroupArgs[0], batchedProductGroups.join())
        .then(results => {
            if (results && results.length > 0) {
                _.each(batchedProductGroupPromises, (promise) => {
                    const productGroup = _.find(results, { Url: promise.id });

                    if (productGroup && productGroup.Items) {
                        promise.q.resolve(buildItems(productGroup, this));
                    } else {
                        promise.q.reject('No products for this produtGroupId');
                    }
                });
            }
        });
};

module.exports = ProductGroupService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/productgroup/productgroup-service.js
 **/